// extracted by mini-css-extract-plugin
export default {"container":"LocationSearch_container__ylYEz","wrapper":"LocationSearch_wrapper__riuR2","image":"LocationSearch_image__Ntevt","input":"LocationSearch_input__NYNYS"};